import { render } from "./DataPlayerRetained.vue?vue&type=template&id=0badf514&scoped=true"
import script from "./DataPlayerRetained.vue?vue&type=script&lang=ts"
export * from "./DataPlayerRetained.vue?vue&type=script&lang=ts"

import "./DataPlayerRetained.vue?vue&type=style&index=0&id=0badf514&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0badf514"

export default script